import React from 'react';
import { observer, inject } from 'mobx-react';
import { addDialogue } from '@/utils/sessionUtils';
import { handleRequest } from '@/utils';
import { addObserver, removeObserver } from '@/utils/intersectionObserver';

import { getTrans, getChildInject } from '@/utils/instantLoaded/tools';
import {

  TRACKING_SECTION,
  TRACKING_OPERATION,
  NO_ORDER_PLACEHOLDER_TEXT,
  TRACKING_TARGET,
  NO_RESULT_FOUND_TEXT,
  NO_MORE_BUTTON,
  NO_ORDER_PLACEHOLDER_TEXT_FOR_SHOPEEFOOD,

} from '@/utils/constants';


import { dispatchTrack, tracker } from '@/utils/tracking';
import './noresult.scss';

const prefixCls = 'no-result';

@tracker
@inject(getChildInject('userStore', 'modalStore', 'agentStore', 'initStore'))
@observer
class NoResult extends React.PureComponent {
  static defaultProps = {
    userStore: {},
    modalStore: {},
  };
  productRef = React.createRef('');

  constructor(props) {
    super(props);

    this.trackingnameForResult = TRACKING_SECTION.orderSelection;

    this.trackingData = {
      chat_session_id: this.props.initStore.sessionId || '0',
      chat_dialogue_id: this.props.modalStore.modalOrderList.dialogueId || '',
      origin: 'Search',
      button_name: getTrans(NO_MORE_BUTTON),
    };
  }


  handleNoResult() {
    const {
      initStore,
      modalStore,
      customCallback = {},
    } = this.props;

    const nodeIdMap = {
      'Order': 'SOP_1_NODE_B7',
      'RR_Check': 'SOP_4_NODE_B7',
      'RR_Raise': 'SOP_5_NODE_A4',
    };
    const curPos = addDialogue({
      from: 'user',
      type: 'Msg',
      data: { content: getTrans(NO_MORE_BUTTON) },
    });
    const { node_id, dialogueId, dialogueType } = modalStore.modalOrderList;

    console.log(dialogueType);

    handleRequest(
      'postMessage',
      {
        session_id: initStore.sessionId,
        dialogue_id: dialogueId,
        input_type: 1,
        message_text: getTrans(NO_MORE_BUTTON),
        message_extra: { node_id: nodeIdMap[dialogueType] },
        ...customCallback,
      },
    );


    const trackingname = 'orderSelection';

    dispatchTrack({
      operation: TRACKING_OPERATION.ACTION_SEAECH,
      target: TRACKING_TARGET.button,
      section: TRACKING_SECTION[trackingname],
      data: {
        chat_session_id: this.props.initStore.sessionId || '0',
        chat_dialogue_id: dialogueId || '',
        origin: 'Search',
        button_name: getTrans(NO_MORE_BUTTON) || '',
      },
    });


    modalStore.HIDE_ORDERLIST_MODAL();
  }

  componentDidMount() {
    addObserver(this.productRef.current);
  }

  componentWillUnmount() {
    removeObserver(this.productRef.current);
  }


  render() {
    const { from } = this.props.initStore;
    const showShopeeFoodText = from === 'shopeeFoodHC';

    return <div className={prefixCls}>
      <p className="info-title">{ getTrans(NO_RESULT_FOUND_TEXT)}</p>
      <p
        ref={this.productRef}
        data-trackingname={this.trackingnameForResult}
        data-trackingdata={ JSON.stringify({ ...this.trackingData })}
        className="info">
        {getTrans(NO_ORDER_PLACEHOLDER_TEXT) || 'You can search by Seller name, Order ID or Product Name'}
      </p>
      {showShopeeFoodText &&
        <p className="info">
          {getTrans(NO_ORDER_PLACEHOLDER_TEXT_FOR_SHOPEEFOOD) || 'Only shopee e-commerce orders will be shown here'}
        </p>}
      <span
        onClick={() => { this.handleNoResult(); }}
        className="no-more-result">
        {
          getTrans(NO_MORE_BUTTON)
        }
      </span>
    </div>;

  }
}

export default NoResult;
